import React from 'react'
import { Link } from 'react-router-dom'
import '../exclusiveContent/ExclusiveContent.css'

const ExclusiveContent = () => {
  return (
    <div className='exclusive-content-sec'>
        <div className='exclusive-tabs-box mb-4'>
            <h6>Monday, 12 October</h6>
            <div className='exclusive-box'>
                <div className='card-exclusive-com d-flex flex-wrap'>
                    <div className='card-box d-flex flex-wrap'>
                        <div className='left-details-box'>
                            <div className='details-box'>
                                <h3>Video</h3>
                                <span className='text-pink'>$100</span>
                                <form action="">
                                    <div className='form-group'>
                                        <input type="text" className="form-control" id="" placeholder="Description of content " />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className='right-btn-box'>
                            <ul className='d-flex flex-wrap justify-content-end'>
                                <li>
                                    <Link rel='stylesheet' to="/" className='btn btn-border btn-accepted'> 
                                        <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25684 6.63687L3.13496 9.57398C3.19834 9.67414 3.27954 9.75556 3.37248 9.81213C3.46541 9.86862 3.56767 9.89882 3.67157 9.90033C3.77379 9.90184 3.875 9.87548 3.96782 9.82343C4.06064 9.7713 4.14275 9.69465 4.20817 9.59908L10.2003 0.779297" stroke="#FD59D9" stroke-linecap="round" stroke-linejoin="round"/></svg> Accepted</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className='exclusive-tabs-box'>
            <h6>Monday, 12 October</h6>
            <div className='exclusive-box'>
                <div className='card-exclusive-com d-flex flex-wrap'>
                    <div className='card-box d-flex flex-wrap'>
                        <div className='left-details-box'>
                            <div className='details-box'>
                                <h3>Video</h3>
                                <span className='text-pink'>$100</span>
                                <form action="">
                                    <div className='form-group'>
                                        <input type="text" className="form-control" id="" placeholder="Description of content " />
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className='right-btn-box'>
                            <ul className='d-flex flex-wrap justify-content-end'>
                                <li>
                                    <Link rel='stylesheet' to="/" className='btn btn-border'>  Cancel</Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ExclusiveContent
